import React from 'react'
import './index.css'
import { LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import { focusEvent, blurEvent } from './bindEvent'
import './index.css'
import Header3 from '../Header/Header3'
import { event } from 'jquery'
import axios from 'axios'
import iconCamera from './images/icon-camera.png'
import md5 from 'blueimp-md5'
import { sm3, sm4 } from 'sm-crypto'
import { message, Upload, Select } from 'antd'
import HomeHearder from '../Pages/Home/NewHome/HomeHearder';
import registerBackground from './images/register-bc.png'
import uploadAvatar from './images/uploadAvatar.png'
const questions = [{
    value: '您的出生地是哪里？',
    lable: '您的出生地是哪里？',
    key: '您的出生地是哪里？'
},
{
    value: '您的学校是什么学校？',
    lable: '您的学校是什么学校？',
    key: '您的学校是什么学校？'
},
{
    value: '您的父亲叫什么名字？',
    lable: '您的父亲叫什么名字？',
    key: '您的父亲叫什么名字？'
}
    // '您的出生地是哪里？',
    // '您的学校是什么学校？',
    // '您的父亲叫什么名字？'
]
const userTypeList = [
    "国土", "农业", "减灾", "测绘", "林业", "城建", "水利", "交通", "地震", "统计", "气象", "海洋", "其他"
]
export default class UserRegister extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            avatarUrl: '',//头像地址
            isAvatarLoading: false,//头像是否在加载中
            firstQuestion: '',//安全验证问题1
            secondQuestion: '',//安全验证问题2
            firstAnswer: '',//回答1
            secondAnswer: '',//回答2

        }
        // this.userCheck = false   // 用户名
        // this.passCheck = false   // 密码
        // this.pass_Check = false  // 确认密码
        // this.emailCheck = false  // 邮箱
        // this.realNameCheck = false  // 真实姓名
        // this.companyCheck = false  //单位
        // this.jobCheck = false   // 职务
        // this.phoneRCheck = false  // 手机号
        // this.question1Check = false  // 问题1
        // this.question2Check = false  // 问题2
        // this.verifyInputCheck = false  // 验证码输入

        this.userRef = React.createRef()   // 用户名
        this.passRef = React.createRef()   // 密码
        this.pass_Ref = React.createRef()  // 确认密码
        // this.emailRef = React.createRef()  // 邮箱（运管未用）
        this.addressRef = React.createRef()   //地址
        this.realNameRef = React.createRef()  // 昵称
        // this.usertypeRef = React.createRef()    //十三类用户
        this.companyRef = React.createRef()  //单位
        // this.jobRef = React.createRef()   // 职务
        this.phoneRef = React.createRef()  // 手机号
        // this.question1Ref = React.createRef()  // 问题1
        // this.question2Ref = React.createRef()  // 问题2
        // this.verifyInputRef = React.createRef()  // 验证码输入
        // this.verifyCodeRef = React.createRef()  // 随机生成的验证码
        // this.verifyCode = ""   // 初始化随机码
        // this.timer = null  // 
    }


    // 处理密码的"眼睛"是否打开
    handleShowPwd = (event) => {
        if (event.target.className === "user-register-content-left-password-hidden") {
            event.target.className = "user-register-content-left-password-show"
            event.target.previousElementSibling.type = "text"

        } else {
            event.target.className = "user-register-content-left-password-hidden"
            event.target.previousElementSibling.type = "password"
        }
    }



    // 在全局定义验证码, 以及重置
    // createCode = () => {
    //     // event.preventDefault()
    //     this.verifyCodeRef.current.value = ""

    //     let code = "", index
    //     let codeLength = 4; //验证码的长度 
    //     let random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
    //         'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //随机数 

    //     for (let i = 0; i < codeLength; i++) { //循环操作  
    //         index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）  
    //         code += random[index]; //根据索引取得随机数加到 this.verifyCode 上  
    //     }

    //     this.verifyCodeRef.current.value = code; //把code值赋给验证码  
    // }


    // 判断表单提交是否正确
    checkForm = () => {
        // debugger
        // // 核验验证码
        // if (this.verifyInputRef.current.value.toLocaleLowerCase() !== this.verifyCodeRef.current.value.toLocaleLowerCase()) {
        //     document.getElementsByClassName("user-register-section-identify-content-info")[0].style.display = "block"
        //     return
        // }
        let nameY = this.userRef.current.value
        let passwordY = this.passRef.current.value;
        let allKey = nameY + "" + passwordY;
        let pass1 = sm3(allKey);
        // let key = pass1.slice(0, 32);//sm4算法要求为128比特，但这边只有32位才能成功加密。
        let key = Buffer.from(pass1.slice(0, 16));//sm4算法要求为128比特，但这边只有32位才能成功加密。
        let encryptedData = sm4.encrypt(passwordY, key);
        console.log("loginRequset-----key", encryptedData);
        // let name = this.userRef.current.value
        // // let password = md5(this.passRef.current.value)
        // let password = this.passRef.current.value;;  //-------运管，记得加密
        // let address = this.addressRef.current.value;
        // // let email = this.emailRef.current.value
        // let realName = this.realNameRef.current.value
        // let usertype = userTypeList[this.usertypeRef.value];
        // let company = this.companyRef.current.value
        // let duty = this.jobRef.current.value
        // let cellphone = this.phoneRef.current.value;
        // let systemBS = "gxfw";
        // let syssource = "ZZX";
        // let avator = this.state.avatarUrl;                           //之后添加头像并修改
        // let question1 = questions[this.q1.value]
        // let question2 = questions[this.q2.value];
        // let answer1 = this.question1Ref.current.value;
        // let answer2 = this.question2Ref.current.value;

        let checkData = {
            name: this.userRef.current.value,
            encryptedData: encryptedData,
            password: this.passRef.current.value,
            secondPassword: this.pass_Ref.current.value,
            address: this.addressRef.current.value,
            // email: this.emailRef.current.value,
            realName: this.realNameRef.current.value,
            // usertype: userTypeList[this.usertypeRef.value],
            company: this.companyRef.current.value,
            // duty: this.jobRef.current.value,
            cellphone: this.phoneRef.current.value,
            systemBS: "gxfw",
            syssource: "ZZX",
            // avator: this.state.avatarUrl,
            question1: this.state.firstQuestion,
            question2: this.state.secondQuestion,
            answer1: this.state.firstAnswer,
            answer2: this.state.secondAnswer,
        }
        let postData1 = { ...checkData };
        // postData1.password = encryptedData;
        /**
         * ！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！
         * 运管说注册的时候不需要做加解密，他们在后台会做处理，只需要登录的时候加解密即可
         * 也就是在注册的时候，设的密码是什么，就给后台传什么值                                                 ！
         * 此处的returnPosData()没有明白是干嘛的，好像是把加密后的密码给了password，然后传给后台了               ！
         * 此处注册时加了一次密，传到后台，后台加了一次密，因此相当于加了两次密，故登录时出错                      
         * 但此处的encryptedData不知道有何用途，是不是对后面登录有用
         * 限限如果看到这里，还请捋一下逻辑，有问题可以找运管确认加解密的问题！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！
         */
        // let postData = this.returnPostData(postData1);
        let flag = this.realCheckPostData(checkData);
        if (!flag)
            return;

        let data = new FormData();
        data.append("userinfo", JSON.stringify(postData1));
        if (this.state.avatarFile && this.state.avatarFile !== "") data.append("file", this.state.avatarFile);
        // axios.post(`${global.yunguanRegister}`+' /omas/user/register', {
        message.info('正在发送邮件，请稍等……')
        // axios.post(global.yunguanRegister,
        axios.post(`/yunguanLoginInfoUrl/omas/user/registerImage`,
            data,
            // {
            //     // axios.post(`${global.yunguanRegister}`+' /omas/user/register', {
            //     // name, password, address, realName, usertype, company, duty, cellphone, systemBS, avator, question1, question2, answer1, answer2
            //     // name, password, address, realName, usertype, company, duty, cellphone, systemBS, question1, question2, answer1, answer2
            //     ...postData
            //     // userinfo: postData,
            // },
            // {
            //     withCredentials: false
            // }
        ).then((res) => {
            console.log('注册调试:',res)
            if (res.data.code === 1) {
                message.success('注册成功！3秒后会跳转至登录界面……')
                // alert('注册成功！')
                setTimeout(() => {
                    this.props.history.push('/UserLogin')
                }, 3000)
            }
            else if (res.data.code === '500') message.error("用户名已存在！");
            else if (res.data.code === '100') message.error("邮箱已存在！");
            else if (res.data.code === '401') message.error("手机号已存在！");
            else if (res.data.code === 0) message.error("邮件发送失败 "+res.data.message);
            else {
                message.error(res.data.message);
                // message.error("注册失败！")
                // alert(res.data.message)
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    // returnPostData = (checkData) => {
    //     let postData = {};
    //     for (let i in checkData) {
    //         if (checkData[i] && checkData[i] !== "" && i === "password") {
    //             postData[i] = checkData["encryptedData"];
    //         }
    //         else if (checkData[i] && checkData[i] !== "" && i !== "secondPassword" && i !== "encryptedData") {
    //             postData[i] = checkData[i];
    //         }
    //     }
    //     return postData;
    // }

    realCheckPostData = (checkData) => {     //真正检验上传数据的函数，上面只为单纯的注册
        let flag = true;
        let rule1 = /^[\u4E00-\u9FA5A-Za-z0-9_@.]{1,25}$/; //校验用户名
        let rule2 = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,16}$/; //校验密码
        let rule3 = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ //校验邮箱
        let rule4 = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ //校验手机号

        if (checkData.name === '' || !checkData.name) { message.error("请填写邮箱！"); flag = false; }
        else if (checkData.password === '' || !checkData.password) { message.error("请填写密码！"); flag = false; }
        // else if (checkData.email === '' || !checkData.email) { message.error("邮箱为空！"); flag = false; }
        else if (checkData.realName === '' || !checkData.realName) { message.error("请填写昵称！"); flag = false; }
        else if (checkData.cellphone === '' || !checkData.cellphone) { message.error("请填写手机号"); flag = false; }
        else if (checkData.question1 === '' || !checkData.question1) { message.error("请填写安全验证问题1"); flag = false; }
        else if (checkData.answer1 === '' || !checkData.answer1) { message.error("请填写回答1"); flag = false; }
        else if (checkData.question2 === '' || !checkData.question2) { message.error("请填写安全验证问题2"); flag = false; }
        else if (checkData.answer2 === '' || !checkData.answer2) { message.error("请填写回答2"); flag = false; }
        else if (checkData.question1 === checkData.question2) { message.error("问题1与问题2不能重复"); flag = false; }
        // else if (!rule1.exec(checkData.name)) { message.error("用户名格式不正确，请输入正确格式！"); flag = false; }
        else if (!rule3.exec(checkData.name)) { message.error("用户名的邮箱格式不正确，请输入正确格式！"); flag = false; }
        else if (!rule2.exec(checkData.password)) { message.error("密码格式不正确，请输入正确格式！"); flag = false; }
        else if (checkData.password !== checkData.secondPassword) { message.error("两次输入密码不一致！"); flag = false; }
        // else if (!rule3.exec(checkData.email)) { message.error("邮箱格式不正确，请输入正确格式！"); flag = false; }
        else if (!rule4.exec(checkData.cellphone)) { message.error("手机号格式不正确，请输入正确格式！"); flag = false; }
        return flag;
    }

    // componentDidMount() {
    //     // 生成随机验证码
    //     // this.createCode()
    // }


    // 校验用户名(即邮箱)
    handleCheckName = () => {
        let regexp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!regexp.exec(this.userRef.current.value)) {
            this.userRef.current.style.border = "1px solid #ee6060"
            // this.userRef.current.parentNode.nextElementSibling.children[0].innerText = "邮箱格式不正确"
            // this.userRef.current.parentNode.nextElementSibling.children[0].style.color = "#ee6060"
        } else {
            this.userRef.current.style.border = "unset"
            // this.userRef.current.parentNode.nextElementSibling.children[0].innerText = ""
        }
    }


    // 校验密码
    handleCheckPwd = () => {
        let regexp = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,16}$/
        if (!regexp.exec(this.passRef.current.value)) {
            this.passRef.current.style.border = "1px solid #ee6060"
            // this.passRef.current.parentNode.nextElementSibling.children[0].innerText = "密码必须是3~16字符，含字母数字"
            // this.passRef.current.parentNode.nextElementSibling.children[0].style.color = "#ee6060"
        } else {
            this.passRef.current.style.border = "unset"
            // this.passRef.current.parentNode.nextElementSibling.children[0].innerText = ""
        }
    }

    // 再次确认密码
    repeatCheckPwd = () => {

        if (this.passRef.current.value === "" || this.passRef.current.value !== this.pass_Ref.current.value) {
            this.pass_Ref.current.style.border = "1px solid #ee6060"
            // this.pass_Ref.current.parentNode.nextElementSibling.children[0].innerText = "密码不一致"
            // this.pass_Ref.current.parentNode.nextElementSibling.children[0].style.color = "#ee6060"
        } else {
            this.pass_Ref.current.style.border = "unset"
            // this.pass_Ref.current.parentNode.nextElementSibling.children[0].innerText = ""
        }
    }

    // 确认邮箱
    // handleCheckMail = () => {
    //     let regexp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    //     this.userRef.current.parentNode.style.border = "1px solid #ee6060"
    //     if (!regexp.exec(this.emailRef.current.value)) {
    //         this.emailRef.current.parentNode.style.border = "1px solid #ee6060"
    //         this.emailRef.current.parentNode.nextElementSibling.children[0].innerText = "邮箱格式不正确"
    //         this.emailRef.current.parentNode.nextElementSibling.children[0].style.color = "#ee6060"
    //     } else {
    //         this.emailRef.current.parentNode.nextElementSibling.children[0].innerText = ""
    //         this.emailRef.current.parentNode.style.border = "1px solid #d3d3d3"
    //     }
    // }

    handleCheckRealName = () => {
        if (this.realNameRef.current.value === '' || this.realNameRef.current.value === undefined || this.realNameRef.current.value === null) {
            this.realNameRef.current.style.border = "1px solid #ee6060"
        } else {
            this.realNameRef.current.style.border = "unset"
        }
    }

    handleCheckPhone = () => {
        let regexp = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (!regexp.exec(this.phoneRef.current.value)) {
            this.phoneRef.current.style.border = "1px solid #ee6060"
            // this.phoneRef.current.parentNode.nextElementSibling.children[0].innerText = "手机号码格式不正确"
            // this.phoneRef.current.parentNode.nextElementSibling.children[0].style.color = "#ee6060"
        } else {
            // this.phoneRef.current.parentNode.nextElementSibling.children[0].innerText = ""
            this.phoneRef.current.style.border = "unset"
        }
    }
    /**
     * @description: 获取安全验证问题
     * @event: getQuestion
     * @return {*}
     */
    getQuestion = (questionSort, value) => {
        switch (questionSort) {
            case 'firstQuestion':
                this.setState({
                    firstQuestion: value
                })
                break;
            case 'secondQuestion':
                this.setState({
                    secondQuestion: value
                })
                break;
            default:
                break;
        }
    }
    /**
     * @description: 获取安全验证问题的答案
     * @event: 
     * @return {*}
     */
    getAnswer = (answersort, event) => {
        switch (answersort) {
            case 'firstAnswer':
                this.setState({
                    firstAnswer: event.target.value
                })
                break;
            case 'secondAnswer':
                this.setState({
                    secondAnswer: event.target.value
                })
            default:
                break;
        }
    }
    changeAvatar = () => {
        document.getElementById('select-img').click()
    }
    uploadImg = (e) => {
        let reader = new FileReader()
        let data = new FormData()
        let nowFile = e.target.files[0];
        if (nowFile.size > 1 * 1024 * 1000) {//    运管接口头像大小限制为1MB
            message.error("请上传大小为1MB以下的图像文件！");
            return;
        }
        data.append('file', e.target.files[0])
        console.log(e.target.files[0])
        this.setState({ avatarFile: e.target.files[0], avatarUrl: URL.createObjectURL(e.target.files[0]) })
        // axios({
        //     method: 'post',
        //     url: global.support.ossUpload + '/oss/upload',
        //     data: data
        // }).then(res => {
        //     console.log(global.support.fileServer + res.data.payload)
        //     this.setState({
        //         avatarUrl: global.support.fileServer + '/' + res.data.payload,
        //         avatarFile: e.target.files[0],
        //     })
        // }).catch(e => {
        //     console.log(e)
        // })
    }

    render() {
        return (
            <React.Fragment>


                <div className="user-register-page">
                    <HomeHearder></HomeHearder>
                    <img className="user-register-background" src={registerBackground}></img>
                    <div className="user-register-wrap-modal">
                        <div className="user-register-content-header">注册</div>
                        <div className="user-register-content-wrap">
                            <div className="user-register-content-left-area">
                                <div className="user-register-content-left-mailbox-wrap">
                                    <input
                                        className="user-register-content-left-mailbox"
                                        type="text"
                                        placeholder="注册邮箱"
                                        ref={this.userRef}
                                        onBlur={this.handleCheckName}
                                        autoComplete="off"
                                    ></input>
                                    <div className="user-register-content-left-mailbox-star">*</div>
                                </div>

                                <div className="user-register-content-left-password-wrap">
                                    <input
                                        type="password"
                                        className="user-register-content-left-password"
                                        placeholder="密码，6-16个字符，同时包含数字和大小写字母"
                                        ref={this.passRef}
                                        onBlur={this.handleCheckPwd}
                                        autoComplete="new-password"
                                    >
                                    </input>
                                    <i className="user-register-content-left-password-hidden" onClick={this.handleShowPwd}></i>
                                    <div className="user-register-content-left-mailbox-star">*</div>
                                </div>
                                <div className="user-register-content-left-password-wrap">
                                    <input
                                        type="password"
                                        className="user-register-content-left-password"
                                        placeholder="确认密码"
                                        ref={this.pass_Ref}
                                        onBlur={this.repeatCheckPwd}
                                        autoComplete="new-password"
                                    >
                                    </input>
                                    <i className="user-register-content-left-password-hidden" onClick={this.handleShowPwd}></i>
                                    <div className="user-register-content-left-mailbox-star">*</div>
                                </div>
                                <div className="user-register-content-left-mailbox-wrap">
                                    <input
                                        className="user-register-content-left-nickname"
                                        placeholder="昵称"
                                        ref={this.realNameRef}
                                        onBlur={this.handleCheckRealName}
                                    >
                                    </input>
                                    <div className="user-register-content-left-mailbox-star">*</div>
                                </div>
                                <div className="user-register-content-left-mailbox-wrap">
                                    <input
                                        className="user-register-content-left-cellphone"
                                        placeholder="手机号码"
                                        ref={this.phoneRef}
                                        onBlur={this.handleCheckPhone}
                                    >
                                    </input>
                                    <div className="user-register-content-left-mailbox-star">*</div>
                                </div>
                                <div className="user-register-content-left-mailbox-wrap">
                                    <input
                                        className="user-register-content-left-address"
                                        placeholder="地址"
                                        ref={this.addressRef}
                                    >
                                    </input>
                                </div>
                                <div className="user-register-content-left-mailbox-wrap">
                                    <input
                                        className="user-register-content-left-company"
                                        placeholder="单位"
                                        ref={this.companyRef}
                                    >
                                    </input>
                                </div>
                            </div>
                            <div className="user-register-content-right-area">
                                <div className="user-register-content-right-upload-avatar-area">
                                    <div className="user-register-content-right-upload-avatar-text">选择头像
                                        {/*<div className="user-register-content-right-first-question-text-star">*</div>*/}
                                    </div>
                                    {
                                        !this.state.avatarUrl ?
                                            <div className="user-register-content-right-upload">
                                                <div className="user-register-content-border">
                                                    <div className="user-register-content-right-upload-avatar-tips" onClick={this.changeAvatar}>
                                                        <img src={uploadAvatar} className="user-register-content-right-upload-icon"></img>上传图片
                                                    </div>

                                                    <input type='file' id="select-img" onChange={(e) => { this.uploadImg(e) }} accept="image/*" style={{ display: "none" }} placeholder="请选择用户头像" />
                                                </div>
                                                <div className="user-register-content-info">
                                                    <p></p>
                                                </div>
                                            </div> :
                                            <div className="user-register-content-right-upload-avatar-wrap" onClick={this.changeAvatar}>
                                                <img src={this.state.avatarUrl} className="user-register-content-right-upload-avatar"></img>
                                                <input type='file' id="select-img" onChange={(e) => { this.uploadImg(e) }} accept="image/*" style={{ display: "none" }} placeholder="请选择用户头像" />
                                            </div>
                                    }
                                </div>
                                <div className="user-register-content-right-first-question-wrap">
                                    <div className="user-register-content-right-first-question-text">安全验证问题1<div className="user-register-content-right-first-question-text-star">*</div></div>
                                    <Select
                                        className="user-register-content-right-first-question-select"
                                        options={questions}
                                        onChange={(value) => this.getQuestion('firstQuestion', value)}
                                    >
                                    </Select>
                                    {/* <select className="user-register-content-right-first-question-select" ref={ref => this.q1 = ref}>
                                        <option value="">请选择您的问题</option>
                                        {
                                            questions.map((q, i) => <option value={i}>{q}</option>)
                                        }
                                    </select> */}
                                </div>
                                <div className="user-register-content-right-first-answer-wrap">
                                    <div className="user-register-content-right-first-answer-text">回答1<div className="user-register-content-right-first-question-text-star">*</div></div>
                                    <input
                                        className="user-register-content-right-first-answer-value"
                                        placeholder="请填写您的回答"
                                        onChange={(event) => this.getAnswer("firstAnswer", event)}
                                    ></input>
                                </div>
                                <div className="user-register-content-right-second-question-wrap">
                                    <div className="user-register-content-right-second-question-text">安全验证问题2<div className="user-register-content-right-first-question-text-star">*</div></div>
                                    <Select
                                        className="user-register-content-right-second-question-select"
                                        options={questions}
                                        onChange={(value) => this.getQuestion('secondQuestion', value)}
                                    >
                                    </Select>
                                    {/* <select className="user-register-content-right-second-question-select" ref={ref => this.q2 = ref}>
                                        <option value="">请选择您的问题</option>
                                        {
                                            questions.map((q, i) => <option value={i}>{q}</option>)
                                        }
                                    </select> */}
                                </div>
                                <div className="user-register-content-right-second-answer-wrap">
                                    <div className="user-register-content-right-second-answer-text">回答2<div className="user-register-content-right-first-question-text-star">*</div></div>
                                    <input
                                        className="user-register-content-right-second-answer-value"
                                        placeholder="请填写您的回答"
                                        onChange={(event) => this.getAnswer("secondAnswer", event)}
                                    ></input>
                                </div>
                            </div>
                        </div>
                        <div className="user-register-content-to-login-wrap">
                            <div className="user-register-contentt-has-account">已有账户，</div>
                            <Link to='/UserLogin'>
                                <div className="user-register-content-to-login">登录</div>
                            </Link>
                        </div>
                        <div className="user-register-contentt-register-button-wrap" >
                            <div className="user-register-contentt-register-button" onClick={this.checkForm}>注册</div>
                        </div>
                    </div>
                </div>
                {/* <div className="user-register-bg">
                    <div className="user-register">
                        <header className="user-register-header">
                            用户注册
                        </header>
                        <section className="user-register-content">
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    用户名
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请输入您的用户名"
                                            ref={this.userRef}
                                            onBlur={this.handleCheckName}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    密码
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="password"
                                            className="user-register-content-input"
                                            placeholder="6-16个字符，包含数字和字母"
                                            ref={this.passRef}
                                            onBlur={this.handleCheckPwd}
                                        />
                                        <i className="user-register-content-hidden" onClick={this.handleShowPwd}></i>
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    确认密码
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="password"
                                            className="user-register-content-input"
                                            placeholder="请再次确认密码"
                                            ref={this.pass_Ref}
                                            onBlur={this.repeatCheckPwd}
                                        />
                                        <i className="user-register-content-hidden" onClick={this.handleShowPwd}></i>
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    地址
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请填写您的地址"
                                            ref={this.addressRef}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    真实姓名
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请填写您的真实姓名"
                                            ref={this.realNameRef}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    用户类型
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <select className="user-register-content-select" ref={ref => this.usertypeRef = ref}>
                                            <option value="" placeholder='可选择用户类型'>可选择用户类型</option>
                                            {
                                                userTypeList.map((q, i) => <option value={i}>{q}</option>)
                                            }
                                        </select>
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    单位
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请填写您的单位"
                                            ref={this.companyRef}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    职务
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请填写您的职务"
                                            ref={this.jobRef}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    手机号码
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请输入手机号码"
                                            ref={this.phoneRef}
                                            onBlur={this.handleCheckPhone}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    头像
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border" style={{ height: "max-content" }}>
                                        <div className='user-register-changePersonalInfo-avatar-C'>
                                            <div className='user-register-changePersonalInfo-avatar-men' onClick={this.changeAvatar}>
                                                <img src={this.state.avatarUrl ? this.state.avatarUrl : iconCamera}
                                                    className={this.state.avatarUrl ? 'user-register-changePersonalInfo-avatar' : 'user-register-changePersonalInfo-avatar-change'} />
                                                <div className='user-register-changePersonalInfo-avatar-changeHoverWord'>头像大小应小于1MB</div>
                                            </div>
                                        </div>
                                        <input type='file' id="select-img" onChange={(e) => { this.uploadImg(e) }} accept="image/*" style={{ display: "none" }} placeholder="请选择用户头像" />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    安全验证问题1
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <select className="user-register-content-select" ref={ref => this.q1 = ref}>
                                            <option value="">请选择您的问题</option>
                                            {
                                                questions.map((q, i) => <option value={i}>{q}</option>)
                                            }
                                        </select>
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    回答1
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请填写您的答案"
                                            ref={this.question1Ref}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    安全验证问题2
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <select className="user-register-content-select" ref={ref => this.q2 = ref}>
                                            <option value="">请选择您的问题</option>
                                            {
                                                questions.map((q, i) => <option value={i}>{q}</option>)
                                            }
                                        </select>
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section">
                                <div className="user-register-content-label">
                                    回答2
                                    <i className="user-register-content-icon">*</i>
                                </div>
                                <div className="user-register-content-insert">
                                    <div className="user-register-content-border">
                                        <input
                                            type="text"
                                            className="user-register-content-input"
                                            placeholder="请填写您的答案"
                                            ref={this.question2Ref}
                                        />
                                    </div>
                                    <div className="user-register-content-info">
                                        <p></p>
                                    </div>
                                </div>
                            </section>
                            <section className="user-register-section-submit">
                                <div className="user-register-section-submit-button" onClick={this.checkForm}>
                                    注&nbsp;&nbsp;&nbsp;&nbsp;册
                                </div>
                                <p className="user-register-section-submit-other">
                                    或&nbsp;已有账号，请&nbsp;
                                    <Link to='/UserLogin'>
                                        <span className="user-register-section-submit-login">登录</span>
                                    </Link>
                                </p>
                            </section>
                        </section>
                    </div>
                </div> */}

            </React.Fragment>
        )
    }
}